import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Sparkles, MapPin } from "lucide-react";
import { SECTORS } from "../../lib/constants";

export const DiscoverForm = ({ form, onChange, loading, onRun }) => (
  <div className="rounded-xl border border-border bg-card p-6">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
      <div className="space-y-1.5 md:col-span-2">
        <Label className="text-xs text-muted-foreground">Città / Zona</Label>
        <div className="relative">
          <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input className="pl-9" placeholder="es. Alessandria, Valenza..." value={form.citta} onChange={(e) => onChange("citta", e.target.value)} data-testid="discover-citta" />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs text-muted-foreground">Settore</Label>
        <Select value={form.settore} onValueChange={(v) => onChange("settore", v)}>
          <SelectTrigger data-testid="discover-settore"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutti i settori</SelectItem>
            {SECTORS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs text-muted-foreground">Quantità</Label>
        <Input type="number" min={3} max={15} value={form.count} onChange={(e) => onChange("count", e.target.value)} data-testid="discover-count" />
      </div>
    </div>
    <Button className="mt-4" onClick={onRun} disabled={loading} data-testid="discover-run-btn">
      <Sparkles className="mr-2 h-4 w-4" /> {loading ? "Generazione in corso..." : "Genera con AI"}
    </Button>
  </div>
);
